<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col cols="8">
          <div class="d-flex flex-column">
            <span class="headline">Efectivo en Caja:</span>
            <small class="caption"
              >Por favor indica la cantidad de billetes o monedas</small
            >
          </div>
        </v-col>
        <v-col cols="4">
          <v-chip large color="cyan" dark>
            <v-icon>mdi-currency-usd</v-icon>
            <span class="text-h5">
              {{ formatDecimal(totalEnCaja) }}
            </span>
          </v-chip>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-card>
            <v-data-table
              :items="denominaciones"
              :headers="headers"
              dense
              item-key="idx"
              :items-per-page="denominaciones.length"
              :item-class="rowBackgroundColor"
              hide-default-footer
              tabindex="0"
            >
              <template v-slot:item.denominacion="{ item }">
                <v-icon class="mr-3">
                  {{ item.icon }}
                </v-icon>
                <strong class="text-subtitle-1 font-weight-bold">
                  {{ item.denominacion }}
                </strong>
              </template>
              <template v-slot:item.cantidad="{ item }">
                  <input
                    class="corte__input text-subtitle-1"
                    :id="item.idx"
                    type="number"
                    min="0"
                    :tabindex="item.idx"
                    :autofocus="(item.idx==1)?true:false"
                    :name="item.denominacion"
                    placeholder="0"
                    v-model="item.cantidad"
                  />
              </template>
              <template v-slot:item.suma="{ item }">
                <span class="text-subtitle-1 font-weight-bold">
                  $ {{ itemSum(item) }}
                </span>
              </template>
            </v-data-table>
        </v-card>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-chip color="cyan" class="mr-2" dark>
        <span class="text-h6"> Total: </span>
        <v-icon small>mdi-currency-usd</v-icon>
        <span class="text-h6">
          {{ formatDecimal(totalEnCaja) }}
        </span>
      </v-chip>
      <v-chip
        :color="saldoCaja < 0 ? 'red' : saldoCaja > 0 ? 'green' : 'default'"
        :dark="saldoCaja != 0"
      >
        Saldo
        <v-icon small>mdi-currency-usd</v-icon>
        <span class="text-h6">
          {{ formatDecimal(saldoCaja) }}
        </span>
      </v-chip>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('close-caja-modal')" tabindex="12"> Cerrar </v-btn>
      <v-btn color="green darken-1" text @click="saveCorte" :disabled="totalEnCaja == 0" tabindex="13">
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formatDecimal } from "../../services/utils";
import { mapActions, mapGetters } from "vuex";
// const {getSettingByName} = api.services.settingsService;
// const {
//   totalCobros,
//   getFondoCaja,
//   totalDepositos,
//   totalRetiros,
//   registrarCorte,
// } = api.services.cajaService; 

export default {
  name: "CorteCaja",
  data() {
    return {
      denominaciones: [],
      headers: [
        {
          text: "Denominacion",
          align: "left",
          sortable: false,
          value: "denominacion",
        },
        {
          text: "Cantidad",
          align: "left",
          sortable: false,
          value: "cantidad",
        },
        {
          text: "Monto",
          align: "rigth",
          sortable: false,
          value: "suma",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["user"]),
    totalEnCaja() {
      return this.denominaciones.reduce((accumulator, current) => (accumulator += current.suma), 0);
    },
    saldoCaja() {
      const cobros = this.totalCobros();
      const fondoCaja = this.getFondoCaja();
      const depositos = this.totalDepositos();
      const retiros = this.totalRetiros();

      const cobrosTotal = cobros.total ? cobros.total : 0;
      const fondoCajaMonto = fondoCaja.monto ? fondoCaja.monto : 0;
      const depositosTotal = depositos.total ? depositos.total : 0;
      const retirosTotal = retiros.total ? retiros.total : 0;

      const totalCaja = this.totalEnCaja ? this.totalEnCaja : 0;
      const totalSistema = (fondoCajaMonto + cobrosTotal + depositosTotal) - retirosTotal;
      const saldo = totalCaja - totalSistema;
      return saldo;
    },
  },
  methods: {
    ...mapActions(["closeCajaModal"]),
    getSettingByName(){},
    totalCobros(){},
    getFondoCaja(){},
    totalDepositos(){},
    totalRetiros(){},
    registrarCorte(){},
    formatDecimal(num){ return formatDecimal(num); },
    itemSum(item) {
      item.suma = item.cantidad * item.value;
      return item.suma;
    },
    rowBackgroundColor(item) {
      const rowIsPair = item.idx % 2 < 1;
      return rowIsPair ? "row-background-color" : "";
    },
    setCorteStartingState() {
      const tipoCambioSetting = this.getSettingByName('precio_dolar');
      const precioDolar = tipoCambioSetting.value;
      this.denominaciones = [
        {
          idx: 1,
          denominacion: "$1000",
          tipo: "billete",
          icon: "mdi-cash-multiple",
          value: 1000,
          cantidad: null,
          suma: 0,
        },
        {
          idx: 2,
          denominacion: "$500",
          tipo: "billete",
          icon: "mdi-cash-multiple",
          value: 500,
          cantidad: null,
          suma: 0,
        },
        {
          idx: 3,
          denominacion: "$200",
          tipo: "billete",
          icon: "mdi-cash-multiple",
          value: 200,
          cantidad: null,
          suma: 0,
        },
        {
          idx: 4,
          denominacion: "$100",
          tipo: "billete",
          icon: "mdi-cash-multiple",
          value: 100,
          cantidad: null,
          suma: 0,
        },
        {
          idx: 5,
          denominacion: "$50",
          tipo: "billete",
          icon: "mdi-cash-multiple",
          value: 50,
          cantidad: null,
          suma: 0,
        },
        {
          idx: 6,
          denominacion: "$20",
          tipo: "billete",
          icon: "mdi-cash-multiple",
          value: 20,
          cantidad: null,
          suma: 0,
        },
        {
          idx: 7,
          denominacion: "$10",
          tipo: "moneda",
          icon: "mdi-currency-usd-circle",
          value: 10,
          cantidad: null,
          suma: 0,
        },
        {
          idx: 8,
          denominacion: "$5",
          tipo: "moneda",
          icon: "mdi-currency-usd-circle",
          value: 5,
          cantidad: null,
          suma: 0,
        },
        {
          idx: 9,
          denominacion: "$2",
          tipo: "moneda",
          icon: "mdi-currency-usd-circle",
          value: 2,
          cantidad: null,
          suma: 0,
        },
        {
          idx: 10,
          denominacion: "$1",
          tipo: "moneda",
          icon: "mdi-currency-usd-circle",
          value: 1,
          cantidad: null,
          suma: 0,
        },
        {
          idx: 11,
          denominacion: "¢50",
          tipo: "moneda",
          icon: "mdi-currency-usd-circle-outline",
          value: 0.5,
          cantidad: null,
          suma: 0,
        },
        {
          idx: 12,
          denominacion: "Dólares",
          tipo: "billete",
          icon: "mdi-cash",
          value: precioDolar,
          cantidad: null,
          suma: 0,
        },
      ];
    },
    saveCorte() {
      const idUsuario = this.user.id;
      const tipo = "corte";
      const saldo = this.saldoCaja;
      const monto = this.totalEnCaja;
      const corteResponse = this.registrarCorte(tipo, monto, saldo, idUsuario);
      console.log(corteResponse);
      this.$emit("done-corte-caja");
      this.closeCajaModal();
      this.setCorteStartingState();
    },
  },
  beforeMount() {
    this.setCorteStartingState();
  },
};
</script>

<style>
.corte__input {
  max-width: 60px;
}
.row-background-color {
  background-color: rgb(244, 247, 247);
}
</style>